import React from "react";

import { Typography } from "@material-ui/core";

import { useAppSelector } from "store";
import { selectStore } from "modules/customer/insights/portfolioNew/portfolioSlice";
import { FootfallMeasureType } from "modules/customer/insights/portfolioNew/footfallNew/footfallMeasureType";
import {
    selectLatestMonthFootfall,
    selectAverageDailyFootfallMeasure
} from "modules/customer/insights/portfolioNew/footfallNew/footfallNewSlice";

const AverageDailyFootfallLevel: React.FC = () => {
    const store = useAppSelector(selectStore);
    const measure = useAppSelector(selectAverageDailyFootfallMeasure);
    const latestMonthFootfall = useAppSelector(selectLatestMonthFootfall);
    const title = measure === FootfallMeasureType.NumberOfVisits ?
        `Average hourly visits per cell within ${store?.name}'s retail centre (${latestMonthFootfall.latestMonthDate.monthLong} ${latestMonthFootfall.latestMonthDate.year})` :
        `Average hourly dwell time per cell within ${store?.name}'s retail centre (${latestMonthFootfall.latestMonthDate.monthLong} ${latestMonthFootfall.latestMonthDate.year})`;
    return (
        <Typography variant="subtitle1" component="div" gutterBottom>
            {title}
        </Typography>
    );
};

export default AverageDailyFootfallLevel;
